<template>
  <div class="login-form bg-white p-8 rounded-lg shadow-md max-w-md w-full">
    <h2 class="text-2xl font-bold text-center mb-6">Login to GeoProperty Hub</h2>
    
    <div v-if="authStore.error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
      {{ authStore.error }}
    </div>
    
    <div v-if="loginSuccess" class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
      Login successful! Redirecting to dashboard...
    </div>
    
    <form @submit.prevent="handleSubmit">
      <div class="mb-4">
        <label for="email" class="block text-gray-700 mb-2">Email</label>
        <input 
          type="email" 
          id="email"
          v-model="form.email"
          class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          placeholder="Your email address"
          required
        >
      </div>
      
      <div class="mb-6">
        <label for="password" class="block text-gray-700 mb-2">Password</label>
        <input 
          type="password" 
          id="password"
          v-model="form.password"
          class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          placeholder="Your password"
          required
        >
      </div>
      
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center">
          <input 
            type="checkbox" 
            id="remember" 
            v-model="form.remember"
            class="h-4 w-4 text-primary-600 focus:ring-primary-500"
          >
          <label for="remember" class="ml-2 block text-gray-700">Remember me</label>
        </div>
        
        <div>
          <a href="#" class="text-primary-600 hover:text-primary-800 text-sm">Forgot password?</a>
        </div>
      </div>
      
      <button 
        type="submit" 
        class="w-full bg-primary-600 text-white py-2 px-4 rounded-lg hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        :disabled="authStore.loading"
      >
        <span v-if="authStore.loading">
          <i class="fas fa-spinner fa-spin mr-2"></i>Logging in...
        </span>
        <span v-else>Login</span>
      </button>
    </form>
    
    <div class="mt-6 text-center">
      <p class="text-gray-600">
        Don't have an account? 
        <router-link to="/signup" class="text-primary-600 hover:text-primary-800">
          Sign up
        </router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { useAuthStore } from '../stores/auth';
import { useRouter } from 'vue-router';

const authStore = useAuthStore();
const router = useRouter();
const loginSuccess = ref(false);

const form = reactive({
  email: '',
  password: '',
  remember: false
});

const handleSubmit = async () => {
  try {
    await authStore.login({
      email: form.email,
      password: form.password
    });
    
    // If login was successful (no errors)
    if (!authStore.error) {
      loginSuccess.value = true;
      
      // Redirect to dashboard after a brief delay
      setTimeout(() => {
        router.push('/dashboard');
      }, 1500);
    }
  } catch (error) {
    console.error('Login submission error:', error);
    loginSuccess.value = false;
  }
};
</script>
